import { render, staticRenderFns } from "./SidebarStatusSelect.vue?vue&type=template&id=8d43ae6a&scoped=true&"
import script from "./SidebarStatusSelect.vue?vue&type=script&lang=js&"
export * from "./SidebarStatusSelect.vue?vue&type=script&lang=js&"
import style0 from "./SidebarStatusSelect.vue?vue&type=style&index=0&id=8d43ae6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d43ae6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
